<template>
  <div class="neg-producao">
    <div class="neg-painel">
      <negocios-campo-data
        label="Aberta a partir de"
        :value="negociosFiltrosProducao.dtini"
        @input="aplicar({ dtini: $event })"
      />

      <negocios-campo-data
        label="Aberta até"
        :value="negociosFiltrosProducao.dtfim"
        @input="aplicar({ dtfim: $event })"
      />

      <q-select
        dense
        clearable
        emit-value
        map-options
        label="Linha"
        option-value="id"
        option-label="nome"
        :options="negociosLinhas"
        :model-value="negociosFiltrosProducao.linha_id"
        @update:model-value="aplicar({ linha_id: $event })"
      />
    </div>

    <div v-if="mostrarVazio" class="neg-vazio neg-vazio--board">
      {{ negociosMensagemProducao }}
    </div>

    <template v-else>
      <div class="neg-totais">
        <div v-for="total in totais" :key="total.rotulo" class="neg-total">
          <div class="neg-total__rotulo">{{ total.rotulo }}</div>
          <div class="neg-total__valor">{{ total.valor }}</div>
        </div>
      </div>

      <q-table
        class="neg-tabela"
        row-key="funcionario_id"
        dense
        flat
        :rows="negociosItensProducao"
        :columns="colunas"
        :loading="negociosCarregandoProducao"
        v-model:pagination="paginacao"
        no-data-label="Nenhum Operador no período"
        loading-label="Carregando produção"
        rows-per-page-label="Por página"
      >
        <template v-slot:top>
          <div class="q-table__title">Produção por Operador</div>
          <q-space />
          <q-btn
            flat
            no-caps
            icon="picture_as_pdf"
            label="Exportar PDF"
            :loading="exportando"
            @click="exportar"
          />
        </template>
      </q-table>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import negociosMixin from "@/mixins/negocios";

export default {
  name: "negocios-producao",
  mixins: [negociosMixin],
  data() {
    return {
      paginacao: { rowsPerPage: 25 },
      exportando: false
    };
  },
  computed: {
    ...mapGetters([
      "negociosItensProducao",
      "negociosTotaisProducao",
      "negociosFiltrosProducao",
      "negociosMensagemProducao",
      "negociosCarregandoProducao",
      "negociosLinhas"
    ]),
    mostrarVazio() {
      return !this.negociosCarregandoProducao && this.negociosItensProducao.length === 0;
    },
    totais() {
      const totais = this.negociosTotaisProducao;

      return [
        { rotulo: "Abertas", valor: this.formatarInteiro(totais.abertas) },
        { rotulo: "Contratadas", valor: this.formatarInteiro(totais.contratadas) },
        { rotulo: "Conversão (contratadas ÷ abertas)", valor: this.formatarConversao(totais.conversao) },
        {
          rotulo: "Valor contratado",
          valor: this.campoVisivel(totais, "valor_contratado")
            ? this.formatarMoeda(totais.valor_contratado)
            : "—"
        },
        {
          rotulo: "Comissão prevista",
          valor: this.campoVisivel(totais, "comissao_prevista")
            ? this.formatarMoeda(totais.comissao_prevista)
            : "—"
        },
        {
          rotulo: "Comissão recebida",
          valor: this.campoVisivel(totais, "comissao_recebida")
            ? this.formatarMoeda(totais.comissao_recebida)
            : "—"
        }
      ];
    },
    colunas() {
      return [
        {
          name: "operador",
          label: "Operador",
          field: "operador",
          align: "left",
          sortable: true,
          format: valor => valor || "—"
        },
        {
          name: "abertas",
          label: "Abertas",
          field: "abertas",
          align: "right",
          sortable: true,
          format: valor => this.formatarInteiro(valor)
        },
        {
          name: "contratadas",
          label: "Contratadas",
          field: "contratadas",
          align: "right",
          sortable: true,
          format: valor => this.formatarInteiro(valor)
        },
        {
          name: "conversao",
          label: "Conversão (contratadas ÷ abertas)",
          field: "conversao",
          align: "right",
          sortable: true,
          format: valor => this.formatarConversao(valor)
        },
        {
          name: "valor_contratado",
          label: "Valor contratado",
          field: "valor_contratado",
          align: "right",
          sortable: true,
          format: (valor, row) =>
            this.campoVisivel(row, "valor_contratado") ? this.formatarMoeda(valor) : "—"
        },
        {
          name: "comissao_prevista",
          label: "Comissão prevista",
          field: "comissao_prevista",
          align: "right",
          sortable: true,
          format: (valor, row) =>
            this.campoVisivel(row, "comissao_prevista") ? this.formatarMoeda(valor) : "—"
        },
        {
          name: "comissao_recebida",
          label: "Comissão recebida",
          field: "comissao_recebida",
          align: "right",
          sortable: true,
          format: (valor, row) =>
            this.campoVisivel(row, "comissao_recebida") ? this.formatarMoeda(valor) : "—"
        }
      ];
    }
  },
  methods: {
    aplicar(filtros) {
      this.$store.commit("negociosFiltrosProducao", filtros);
      this.$store.dispatch("carregarNegociosProducao");
    },
    exportar() {
      this.exportando = true;

      this.$store.dispatch("exportarNegociosProducao").then(resposta => {
        this.exportando = false;

        this.avisar(resposta.message, resposta.success ? "green" : "orange");

        if (resposta.success && resposta.linkArquivo) {
          window.open(resposta.linkArquivo, "_blank");
        }
      });
    },
    campoVisivel(objeto, campo) {
      return Object.prototype.hasOwnProperty.call(objeto, campo);
    },
    formatarInteiro(valor) {
      return String(Number(valor || 0));
    },
    formatarConversao(valor) {
      if (valor === null || valor === undefined) {
        return "—";
      }

      return Number(valor).toFixed(2).replace(".", ",") + " %";
    }
  }
};
</script>
